/** @format */

import React from 'react';
import {createRoot} from 'react-dom/client';
import UserTextSetting from './components/user_text_setting/user_text_setting';

export default () => {
    let bind = document.getElementById('user-text-setting');
    if (bind) {
        const root = createRoot(bind);
        let user_id = bind.dataset.userId;

        // Entrypoint that binds everything to the DOM
        // Don't put anything else in here
        root.render(<UserTextSetting id={user_id} />);
    }

    return null;
};
